import { Session } from '@ais-ui/auth';
import { Bookmark } from './bookmarks/types';

export type BoundingBox = {
  crs: string;
  extent: number[];
};

export type WMSLayerInfo = {
  id: string;
  title: string;
  name: string;
  coordinateSystems: string[];
  boundingBox: BoundingBox[];
  enabled: boolean;
  isBase?: boolean;
};

export type WMSInfo = {
  id: string;
  enabled: boolean;
  exception: string;
  name: string;
  patch: null | string;
  refreshrate: number;
  selected: string[];
  singletile?: boolean;
  singleTile?: boolean;
  baseMap?: boolean;
  trans?: number;
  transparency?: number;
  url: string;
  version: string;
  layers?: WMSLayerInfo[];
  /** Whether to use proxy for CORS. Auto-detected when adding WMS layer. */
  useProxy?: boolean;
};

export type VectorTile = {
  id: string;
  enabled: boolean;
  name: string;
  url: string;
};

export type RadarOverlayInfo = {
  id: string;
  name: string;
  url: string;
  enabled: boolean;
  opacity: number;
};

export interface Settings {
  'assetDisplay.mapengine': {
    enableUserSpecificS57: boolean;
    fEnableOSM: boolean;
    fEnableS57: boolean;
    osmBaseName: string;
    osmBaseUrl: string;
    osmHeaders: any[];
    displayProjection?: string;
    viewParam: {
      center: {
        lat: number;
        lon: number;
      };
      zoomLevel: number;
    };
  };
  'ribbonPlugin.settings': Record<string, any>;
  wmsSettings: WMSInfo[];
  vectorTiles: VectorTile[];
  radarSettings?: RadarOverlayInfo[];
  homeBookmark?: Bookmark;
  show_ports?: boolean;
  favorite_port?: string;
  favorite_port_data?: {
    id: number;
    name: string;
    country: string;
    locode: string;
    position: {
      coordinates: number[];
    };
  };
  showTargetCountBadge?: boolean;
  /** User's preferred theme: 'light', 'dark', or 'system' */
  theme?: 'light' | 'dark' | 'system';
}

export const getSettings = async (session: Session): Promise<Settings> => {
  const response = await session.request('get', {
    defaultSettings: false,
    serverUid: 'd4bd4710-1765-4476-8969-09ab9d0b676f',
  });

  return JSON.parse(response);
};

export const getDefaultSettings = async (
  session: Session,
): Promise<Settings> => {
  const response = await session.request('get', {
    defaultSettings: true,
    serverUid: 'd4bd4710-1765-4476-8969-09ab9d0b676f',
  });

  return JSON.parse(response);
};

export const setSettings = async (
  session: Session,
  settings: Settings,
): Promise<null> => {
  const response = await session.request('set', {
    configuration: JSON.stringify(settings),
  });

  return response;
};
